import React from "react";
import Notes from "../../components/Notes/Notes";
import { useParams } from "react-router-dom";
function NotesSection({status}) {
  const { order_id } = useParams();

  console.log("order_id", order_id);
  return (
    <>
      <Notes module_type={"ORDER"} module_id={order_id} status={status}/>
    </>
  );
}

export default NotesSection;
